import { useSelector } from 'react-redux'

import Package from '@/components/PDP/Packages/Package'
import { translate } from '@/utils/translations'

import Section from '../Section'
const SECTION_KEY = 'packages'

const PackageSection = () => {
  const packages = useSelector(state => state.asset.packages)

  return(
    <Section
      condition={packages.length > 4}
      eventKey={SECTION_KEY}
      title={translate('purchase.entire_collection')}
    >
      {packages.map((asset, index) => {
          return <Package key={index} {...{ asset }} />
        })}
    </Section>
  )
}

export default PackageSection
